import React, { useEffect, useRef, useState } from "react";
import ViewCart from "../common/ViewCart";
import Readmore from "../common/Readmore";
import { useDispatch, useSelector } from "react-redux";
import Coupons from "./Coupons";
import {
  addCartItem,
  updateAciModal,
  updateSelectedItem,
  updateCartLoader,

} from "../../redux/actions/cartActions";
import uuid from "uuid";
import Auth from "../../auth/Auth";
import { http } from "../../helpers/http";
import {
  clearTipAdditionalInfo,
  getCartData,
  placeholderHandler,
} from "../../helpers/help";
import { toast } from "react-toastify";
import { CART } from "../../eums/messages";
import { updateOnboardingState } from "../../redux/actions/authActions";
import { useLocation, useOutletContext } from "react-router-dom";
import ReplaceCartItems from "../modals/ReplaceCartItems";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ItemQuantity from "./ItemQuantity";
import moment from "moment";
import { useParams } from "react-router-dom";
import { Table } from "react-bootstrap";

function Menu(props) {
  // const { outletId } = props;
  const { menuImg } = props;
  const [view, setView] = useState(false);
  let { outletId } = useParams();
  // let { outletId } = useOutletContext();
  let restaurantInfo = useSelector((state) => state.restaurant.info);
  const isUserloggedIn = useSelector((state) => state.auth.isUserloggedIn);
  const isDesktopMode = useSelector((state) => state?.general?.isDesktopMode);

  const cartItems = useSelector((state) => state.cart.cartItems);
  const editData = useSelector((state) => state.cart.editData);
  const cartOutletId = useSelector(
    (state) => state.cart.viewCartData.dishes?.outletDetails.outletId
  );
  const dispatch = useDispatch();
  // const [customisation, setCustomisation] = useState([]);
  const [rciModal, setRciModal] = useState(false);
  const ifNewOutlet = cartOutletId ? cartOutletId !== outletId : false;
  const isEditMode = !!Object.keys(editData).length;
  const customisation = useRef([]);
  const [chosenItem, setChosenItem] = useState({});
  const [tabKey, setTabKey] = useState(null);

  const [activeTab, setActiveTab] = useState();
  let restroData;
  // const location = useLocation();
  if (sessionStorage.getItem("restaurantInfo")) {
    restroData = JSON.parse(sessionStorage.getItem("restaurantInfo"));
  }


  // console.log('restroData', restroData);


  const checkItemSame = () => {
    let foundItem = false;
    if (cartItems) {
      foundItem = cartItems.filter(
        (dishItem) => dishItem.dishId === chosenItem.dishId
      );

      if (foundItem) {
        foundItem = foundItem.find((qwe) => {
          //check previous item's customization is equal to new item's customization
          //check customisation length
          if (
            "" !== qwe.spl_instruction ||
            customisation.current.length !== qwe.customisation.length
          ) {
            return false;
          }
          const result = customisation.current.every((newCustomisation) => {
            const isCustomisationExist = qwe.customisation.some(
              (cId) => cId.dishCustomisationId === newCustomisation.elementId
            );
            return isCustomisationExist;
          });

          return result;
        });
      }
    }
    return foundItem;
  };

  const updateCartItem = (payload) => {
    dispatch(updateCartLoader(true));
    http(
      {
        method: "POST",
        url: `updateCart`,
        isSecure: true,
        body: payload,
      },
      (res) => {
        if (res.error === "false") {
          getCartData();
          toast.success(CART.ITEM_UPDATED);
        }
      }
    );
  };

  const formattedCustomisation = () => {
    return customisation.current.map((item) => ({
      dishCustomisationId: item.elementId,
    }));
  };

  const addItemToCart = () => {
    dispatch(updateAciModal(false));

    const isItemSame = checkItemSame();
    if (isItemSame) {
      const apiData = {
        cartId: isItemSame.cartId,
        udId: Auth.userInfo()?.udId,
        outletId: cartOutletId,
        quantity: isItemSame.quantity + 1,
        spl_instruction: "",
        os: "web",
        customisationId: JSON.stringify(formattedCustomisation()),
        // uuId: uuid.v4().toUpperCase(),
      };
      updateCartItem(apiData);
    } else {
      const newCartItem = {
        quantity: 1,
        customisation: formattedCustomisation(),
        dishId: chosenItem.dishId,
        uuId: uuid.v4().toUpperCase(),
        outletId: cartOutletId,
        spl_instruction: "",
        os: "web",
      };

      const bodyData = {
        order_type: "Take Out",
        spl_instruction: "",
        outletId,
        udId: Auth.userInfo().udId,
        uuId: uuid.v4().toUpperCase(),
        os: "web",
        dishes: JSON.stringify(
          ifNewOutlet ? [newCartItem] : [...cartItems, newCartItem]
        ),
      };

      dispatch(updateCartLoader(true));
      http(
        {
          method: "POST",
          url: `addToCart`,
          isSecure: true,
          body: bodyData,
        },
        (res) => {
          if (res.error === "false") {
            toast.success(CART.ITEM_ADDED);
            dispatch(addCartItem(newCartItem));
            clearTipAdditionalInfo();
          }
          if (res.error === "true") {
            toast.error(res.errorMessage);
            dispatch(updateCartLoader(false));
          }
        },
        (res) => { }
      );
    }
  };

  const submitHandler = () => {
    if (!Auth.isUserAuthenticated()) {
      dispatch(updateAciModal(false));
      dispatch(updateOnboardingState("login"));
      return;
    }

    if (!isEditMode && ifNewOutlet) {
      setRciModal(true);
    } else {
      addItemToCart();
    }
  };


  useEffect(() => {
    restaurantInfo = {};
  }, []);

  useEffect(() => {
    // add cart item directly without opening cart modal.
    if (Object.keys(chosenItem).length && chosenItem?.dishCustomisation) {
      const selectedAddOns = [];
      chosenItem.dishCustomisation.forEach((dishCustomisationItem) => {
        dishCustomisationItem.customizableDishItems.forEach(
          (customizableDish) => {
            //only add those customisations which isSelected 1.
            customizableDish.isSelected &&
              selectedAddOns.push(customizableDish);
          }
        );
      });
      customisation.current = [...selectedAddOns];
      submitHandler();
    }
  }, [chosenItem]);

  useEffect(() => {
    if (restaurantInfo?.dishes && !tabKey) {
      // (tabKey == null && restaurantInfo.dishes.length > 0) ?  : null;
      if (restaurantInfo.dishes.length > 0) {
        // if(tabKey==null && restaurantInfo?.dishes){
        //   setTabKey(;
        // }

        setTabKey(restaurantInfo.dishes[0]?.categoryId)
      }
    }
  }, [restaurantInfo, tabKey]);


  // const handleCopyToClipboard = () => {
  //   const path = window.location.pathname;
  //   copy(path);
  //   // You can display a message or perform any action after copying to clipboard
  //   alert(`Copied to clipboard: ${path}`);
  // };
  return (
    <>
      {/* {isUserloggedIn && <Coupons />} */}

      <div className="product_view_dis mt-xl-5 mt-4">
        <div className="d-flex">
          <div className="col-left me-xl-4 w-100">
            <div className="d-flex align-items-center justify-content-between">
              <h5 className="head5 mb-0">Menu</h5>
              {!restaurantInfo?.dishes && (
                <p className="nodata_found_menu">No data found</p>
              )}
              <div className="custab_btn d-flex">
                <button
                  onClick={() => setView(false)}
                  className={`${view === false ? "active" : ""} tabbtn`}
                >
                  <img
                    src="./assets/img/unGrid_white.svg"
                    alt="arrow back"
                    className="Active_grout-item"
                  />
                  <img
                    src="./assets/img/unGrid.svg"
                    alt="arrow back"
                    className="deActive_grout-item"
                  />
                </button>
                <button
                  onClick={() => setView(true)}
                  className={`${view ? "active" : ""} tabbtn`}
                >
                  <img
                    src="./assets/img/grid_item_img.svg"
                    alt="grid active"
                    className="Active_grout-item"
                  />
                  <img
                    src="./assets/img/grid_item_img_black.svg"
                    alt="grid deactive"
                    className="deActive_grout-item"
                  />
                </button>
              </div>
            </div>
            <div className="tabResMenu">
              {(tabKey || tabKey === 0) ? <div className="tabContainer">
                <Tabs
                  defaultActiveKey={`category-id-${tabKey}`}
                  id="uncontrolled-tab-example"
                  className="mb-3 mt-3"
                >
                  {restaurantInfo?.dishes?.map(
                    (item, index) => {
                      return (
                        Array.isArray(item.categoryValues) && (
                          <Tab
                            eventKey={`category-id-${item.categoryId}`}
                            title={item.categoryName}
                          >
                            {view === false ? (
                              <div className="product_dis_s">
                                {item?.categoryValues?.map((sub_Item, index) => (
                                  <div
                                    //className="white_box pointer mb-4"
                                    // className={`white_box pointer mb-sm-4 mb-3 ${restaurantInfo.emergency_close
                                    //   ? "disabling"
                                    //   : ""
                                    // className={`white_box pointer mb-sm-4 mb-3 ${restaurantInfo.emergency_close ||
                                    //   !restaurantInfo.restaurant_business_day
                                    //     ?.is_restro_online
                                    //   ? "disabling"
                                    //   : ""
                                    //   }`}
                                    // className={`white_box pointer mb-sm-4 mb-3 ${(restaurantInfo.emergency_close === 1 || restaurantInfo?.is_restro_online === 1 || restaurantInfo?.pickup_availability === 0)
                                    //   ? "disabling"
                                    //   : ""
                                    //   }`}

                                    className={`white_box pointer mb-sm-4 mb-3 ${(restaurantInfo?.emergency_close === 0 ?
                                      ((restaurantInfo?.is_restro_online === 1 ?
                                        restaurantInfo.pickup_availability === 0 ?
                                          "disabling" :
                                          ""
                                        : "disabling")) : "disabling"

                                    )
                                      }`}
                                    onClick={(event) => {
                                      event.stopPropagation();

                                      if (sub_Item.stock_status === 1) {
                                        // toast.error("Out of stock");
                                      } else if (
                                        sub_Item.dishavailable === false
                                      ) {
                                        // toast.error("Not Available");
                                      } else {
                                        dispatch(updateAciModal(true));
                                        dispatch(
                                          updateSelectedItem({ ...sub_Item })
                                        );
                                      }
                                    }}
                                  >
                                    <div className="d-flex justify-content-between flex-sm-row flex-column">
                                      <div className="d-flex">
                                        <div className="add_gimgSw fixwidthp">
                                          {sub_Item?.dishImage ? (
                                            <img
                                              src={sub_Item?.dishImage}
                                              onError={placeholderHandler}
                                              alt="img product"
                                            />
                                          ) : (
                                            <img
                                              src={restroData?.image ? restroData?.image :menuImg?menuImg: './assets/img/Boomerang.png'}
                                              // src="./assets/img/Boomerang.png"
                                              onError={placeholderHandler}
                                              alt="img product"
                                            />
                                          )}
                                        </div>
                                        <div>
                                          <h6 className="d-inline-block head6 mb-1 blackC text-break">
                                            {sub_Item.dishName}
                                            {sub_Item.isVeg === 1 ? (
                                              <img
                                                src="./assets/img/vegi_icon.svg"
                                                alt="veg img"
                                                className="ms-2"
                                              />
                                            ) : (
                                              ""
                                            )}
                                          </h6>
                                          <p className="mb-0 grayS">
                                            {sub_Item.description}{" "}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="food-price ms-2">
                                        {sub_Item &&
                                          sub_Item.dishavailable &&
                                          !sub_Item.stock_status && (
                                            <>
                                              <span className="d-flex flex-column-reverse align-items-end">
                                                <span className="txt">
                                                  {/* {!!sub_Item.dishCustomisation.length &&
                                                    "Customizable"}{" "} */}
                                                  {
                                                    sub_Item.isCustomizable === 1 && sub_Item.dishCustomisation.length > 0 ? <div>Customizable</div> : ""
                                                  }
                                                </span>{" "}
                                                <div className="d-flex align-items-center mb-2">
                                                  <div className="me-md-4 me-2">
                                                    <b className="fz14">{sub_Item.displayPrice}</b>
                                                  </div>
                                                  <img
                                                    className="iconPlus "
                                                    src="./assets/img/addPlus_icon.svg"
                                                    alt="add icon"
                                                    onClick={(event) => {
                                                      event.stopPropagation();

                                                      if (
                                                        sub_Item.stock_status ===
                                                        1
                                                      ) {
                                                        toast.error(
                                                          "Out of Stock"
                                                        );
                                                      } else if (
                                                        sub_Item.dishavailable ===
                                                        false
                                                      ) {
                                                        toast.error(
                                                          "Not Available"
                                                        );
                                                      } else {
                                                        dispatch(
                                                          updateAciModal(true)
                                                        );
                                                        dispatch(
                                                          updateSelectedItem({
                                                            ...sub_Item,
                                                          })
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </div>{" "}
                                                {/* <ItemQuantity dishId={sub_Item.dishId} /> */}
                                              </span>
                                            </>
                                          )}
                                        {sub_Item && sub_Item.stock_status ? (
                                          <div className="unavailable d-flex justify-content-end flex-column align-items-end">
                                            <span className="disUN text-center mb-2">Out of Stock</span>
                                          </div>
                                        ) : (
                                          !sub_Item.dishavailable && (
                                            <div className="unavailable d-flex justify-content-end flex-column align-items-end">
                                              <span className="disUN text-center mb-2">
                                                Dish Unavailable
                                              </span>
                                              <p className="mb-0 txt text-nowrap">
                                                Served
                                                {moment(
                                                  sub_Item?.availableFrom,
                                                  " h:mm a"
                                                ).format(" h:mm A")}{" "}
                                                -
                                                {moment(
                                                  sub_Item?.availableTo,
                                                  " h:mm a"
                                                ).format(" h:mm A")}
                                              </p>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="product_dis_s product_dis_grid">
                                {item.categoryValues.map((sub_Item, index) => (
                                  <div
                                    // key={`dish-id-${sub_Item?.dishId}`}
                                    className={`white_box pointer mb-sm-4 mb-3 ${restaurantInfo.emergency_close
                                      ? "disabling"
                                      : ""
                                      }`}
                                    onClick={(event) => {
                                      event.stopPropagation();

                                      if (sub_Item.stock_status === 1) {
                                        // toast.error("Out of stock");
                                      } else if (
                                        sub_Item.dishavailable === false
                                      ) {
                                        // toast.error("Not Available");
                                      } else {
                                        dispatch(updateAciModal(true));
                                        dispatch(
                                          updateSelectedItem({ ...sub_Item })
                                        );
                                      }
                                    }}
                                  >
                                    <div className="add_gimg">
                                      <div className="d-lg-flex mb-2">
                                        <div className="add_gimgSw mb-2 mb-lg-0">
                                          {sub_Item?.dishImage ? (
                                            <img
                                              src={sub_Item?.dishImage}
                                              onError={placeholderHandler}
                                              alt="img product"
                                            />
                                          ) : (
                                            <img
                                            src={restroData?.image ? restroData?.image :menuImg?menuImg: './assets/img/Boomerang.png'}
                                              // src="./assets/img/Boomerang.png"
                                              onError={placeholderHandler}
                                              alt="img product"
                                            />
                                          )}
                                        </div>
                                        <div>
                                          <h6 className="d-inline-block head6 mb-1 blackC text-break">
                                            {sub_Item.dishName}
                                            {sub_Item.isVeg === 1 ? (
                                              <img
                                                src="./assets/img/vegi_icon.svg"
                                                alt="veg img"
                                                className="ms-2"
                                              />
                                            ) : (
                                              ""
                                            )}
                                            {/* <img src="./assets/img/vegi_icon.svg" alt="veg img" className="ms-2" /> */}
                                          </h6>
                                          <p className="mb-0 grayS">
                                            {sub_Item.description}{" "}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="d-flex justify-content-between align-items-center  min3h">
                                        {sub_Item &&
                                          sub_Item.dishavailable &&
                                          !sub_Item.stock_status && (
                                            <>
                                              <span className="d-flex align-items-center justify-content-between w-100">
                                                <div className="me-md-4 me-2">
                                                  <b>
                                                    {sub_Item.displayPrice
                                                      ? sub_Item.displayPrice.charAt(
                                                        0
                                                      ) +
                                                      Number(
                                                        sub_Item.displayPrice.split(
                                                          "$"
                                                        )[1]
                                                      ).toFixed(2)
                                                      : sub_Item.displayPrice}
                                                  </b>
                                                </div>
                                                <div className="d-flex align-items-center ms-2">
                                                  <div className="txt me-2">
                                                    {!!sub_Item.dishCustomisation.length &&
                                                      "Customizable"}{" "}
                                                  </div>{" "}
                                                  <img
                                                    className="iconPlus "
                                                    src="./assets/img/addPlus_icon.svg"
                                                    alt="add icon"
                                                    onClick={(event) => {
                                                      event.stopPropagation();

                                                      if (
                                                        sub_Item.stock_status ===
                                                        1
                                                      ) {
                                                        // toast.error("Out of stock");
                                                      } else if (
                                                        sub_Item.dishavailable ===
                                                        false
                                                      ) {
                                                        // toast.error("Not Available");
                                                      } else {
                                                        dispatch(
                                                          updateAciModal(true)
                                                        );
                                                        dispatch(
                                                          updateSelectedItem({
                                                            ...sub_Item,
                                                          })
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </div>{" "}
                                                {/* <ItemQuantity dishId={sub_Item.dishId} /> */}
                                              </span>
                                            </>
                                          )}
                                        {sub_Item && sub_Item.stock_status ? (
                                          <div className="unavailable d-flex justify-content-end flex-column align-items-end w-100">
                                            <span className="disUN text-center mb-2">Out of Stock</span>
                                          </div>
                                        ) : (
                                          !sub_Item.dishavailable && (
                                            <div className="unavailable d-flex justify-content-end flex-column align-items-end w-100">
                                              <span className="disUN text-center mb-2">
                                                Dish Unavailable
                                              </span>
                                              <p className="mb-0 txt text-nowrap">
                                                Served
                                                {moment(
                                                  sub_Item?.availableFrom,
                                                  " h:mm a"
                                                ).format(" h:mm A")}{" "}
                                                -
                                                {moment(
                                                  sub_Item?.availableTo,
                                                  " h:mm a"
                                                ).format(" h:mm A")}
                                              </p>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </Tab>
                        )
                      )
                    }

                  )}
                  {/*                
                <Tab eventKey="lunch" title="Lunch">
                  Tab content for Profile
                </Tab>
                <Tab eventKey="brunch" title="Brunch" >
                  Tab content for lunch
                </Tab>
                <Tab eventKey="dinner" title="Dinner" >
                  Tab content for dinner
                </Tab> */}
                </Tabs>
              </div> : null}
            </div>
          </div>
          <div className="col-right right_box_hug d-xl-block d-none">
            {isDesktopMode && <ViewCart />}
          </div>
        </div>
      </div>
      <div className="product_view_dis mt-3">
        {/* <div className="d-flex">
          <div className="col-left me-lg-4 w-100">
            <h4 className="head4 mb-4">Menu </h4>
            {!restaurantInfo?.dishes && (
              <p className="nodata_found_menu">No data found</p>
            )}
            {restaurantInfo?.dishes?.map(
              (item, index) =>
                Array.isArray(item.categoryValues) && (
                  <div key={`category-id-${item.categoryId}`} className="mt-4">
                    <h5 className="head5">{item.categoryName}</h5>
                    <div className="product_dis">
                      {item.categoryValues.map((sub_Item, index) => (
                        <div
                          key={`dish-id-${sub_Item?.dishId}`}
                          className={`white_box pointer ${restaurantInfo.isClosed ||
                            !restaurantInfo.restaurant_current_business_day
                              ?.is_restro_online
                            ? "unable-to-buy"
                            : ""
                            }`}
                          onClick={(event) => {
                            event.stopPropagation();

                            if (sub_Item.stock_status === 1) {
                              toast.error("Out of stock");
                            } else if (sub_Item.dishavailable === false) {
                              toast.error("Not Available");
                            } else {
                              dispatch(updateAciModal(true));
                              dispatch(updateSelectedItem({ ...sub_Item }));
                            }
                          }}
                        >
                          <div className="">
                            <h6 className="d-inline-block head6 mb-1 blackC">
                              {sub_Item.dishName}
                              {sub_Item.isVeg === 1 ? (
                                <img
                                  src="./assets/img/vegi_icon.svg"
                                  alt="veg img"
                                  className="ms-2"
                                />
                              ) : (
                                <img
                                  src="./assets/img/nv.svg"
                                  alt="veg img"
                                  className="ms-2"
                                />
                              )}
                            </h6>
                            <h6 className="head6 mb-2 blackC">
                              {sub_Item.displayPrice}
                            </h6>
                            <Readmore>{sub_Item.description}</Readmore>
                          </div>
                          {sub_Item &&
                            sub_Item.dishavailable &&
                            !sub_Item.stock_status ? (

                            <div className="text-end">
                              <button
                                className="cusbtn sm_cusbtn"
                                onClick={(event) => {
                                  setChosenItem({ ...sub_Item });
                                }}
                              >
                                ADD TO CART
                              </button>
                            </div>

                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )
            )}
          </div>
          {isDesktopMode && <ViewCart />}
        </div> */}
      </div>
      <ReplaceCartItems
        rciModal={rciModal}
        setRciModal={setRciModal}
        addItemToCart={addItemToCart}
      />
    </>
  );
}

export default Menu;
